import React, { useEffect, useRef } from 'react'
import { Spinner } from 'lib/ui/components'
import { Container, Section, SelectorContent } from 'app/sofia/scenes/ProductSelector/styled'
import { ProgressBar } from 'components/ProgressBar'
import {
  Avatar,
  Layout,
  ProductSelectorModal,
  ProductSelectorQuestions
} from 'components/ProductSelector'
import { useProductSelector } from 'hooks/productSelector'
import { PRODUCT_SELECTOR_CODE } from 'app/sofia/resources/constants'

export const Questionaire = () => {
  const {
    loading,
    questionData,
    resultsReady,
    step,
    setStep,
    submitAnswer,
    stepBack,
    showResults,
    setShowResults,
    questions,
    saveCustomerAnswers,
    savingAnswer,
    noQuestions,
    setCustomerEmail,
    totalQuestions
  } = useProductSelector({
    questionnaireCode: PRODUCT_SELECTOR_CODE
  })
  const { title, options, id: questionId, type } = questionData ?? {}
  const scrollRef = useRef<HTMLDivElement>(null)
  const firstRun = useRef(true)

  const isFirstStep = step === 0
  const isReviewStep = resultsReady && !questionData
  const currentStep = step
  const sectionClass = isReviewStep ? 'review' : currentStep

  const handleSubmit = (values: Record<string, any>) => {
    submitAnswer(values)
  }

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false
      return
    }

    if (isReviewStep || showResults) {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    } else {
      const top = scrollRef?.current?.offsetTop ? (scrollRef?.current?.offsetTop - 25) : 0
      window.scrollTo({ left: 0, top: top, behavior: 'smooth' })
    }
  }, [step, isReviewStep, showResults])

  return (
    <Layout isReviewStep={isReviewStep}>
      <>
        <Avatar isReview={isReviewStep} />
        <Section className={`step step-${sectionClass}`}>
          {savingAnswer ? (
            <Spinner />
          ) : (
            <Container>
              <SelectorContent>
                {noQuestions ? (
                  <div>
                    Sorry, we couldn't find questions.
                    <br />
                    Please, try again later
                  </div>
                ) : (
                  <>
                    {!isReviewStep && totalQuestions && (
                      <ProgressBar
                        totalCount={totalQuestions}
                        currentItem={currentStep + 1}
                      />
                    )}
                    <ProductSelectorQuestions
                      loading={loading}
                      title={title}
                      type={type}
                      options={options}
                      handleSubmit={handleSubmit}
                      isReviewStep={isReviewStep}
                      questionId={questionId}
                      isFirstStep={isFirstStep}
                      setStep={setStep}
                      stepBack={stepBack}
                      step={step}
                      setShowResults={setShowResults}
                      questions={questions}
                      saveCustomerAnswers={saveCustomerAnswers}
                    />
                  </>
                )}
              </SelectorContent>
            </Container>
          )}
        </Section>
        <ProductSelectorModal
          setCustomerEmail={setCustomerEmail}
        />
      </>
    </Layout>
  )
}
